import apiConfig from "../config/api";

const documentApi = `${apiConfig.apiUri}api/losses/document`;
const getToken = () => localStorage.getItem("AccessToken");

export const GetSiniestroDocumentsApi = (idSiniestro, tipoBusqueda) =>
  fetch(`${documentApi}/${idSiniestro}/${tipoBusqueda}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  });

export const GetSiniestroDocumentPDFApi = (idPrestacion) =>
  fetch(`${documentApi}/pdf/${idPrestacion}`, {
    method: "GET",
    headers: {
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Content-Type": "application/octet-stream",
      "Content-Disposition": "inline; filename='doc.pdf'",
      Authorization: `Bearer ${getToken()}`,
    }
  })
    .then((response) => response.blob())
    .catch((error) => {
      console.log(error);
    });

export const GetDocument = (documentId) =>
  fetch(documentId, {
    method: "GET",
    headers: {
      // TODO: change on MS-Losses publishing!!
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      //"Ocp-Apim-Subscription-Key": "c08395f6acd5403fbcb30560053e4dec",
      //"Ocp-Apim-Subscription-Key": "8b84a1d721a6454aab5daa4b508fea2c",
      "Content-Type": "application/octet-stream",
      "Content-Disposition": "inline; filename='doc.pdf'",
      Authorization: `Bearer ${getToken()}`,
    },
  })
    .then((response) => response.blob())
    .catch((error) => {
      console.log(error);
    });
